var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"btn-start",attrs:{"type":"button"},on:{"click":_vm.openModal}},[_vm._v("Start Now")]),_vm._v(" "),_c('transition',{attrs:{"name":"slide-fade"}},[(_vm.showPopup)?_c('popup',{on:{"close":function($event){_vm.showPopup = false}}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23d77efc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StartNow.vue
// module id = 29
// module chunks = 0